import React, {useContext, useState} from "react";
import { StyledCardsList, StyledHeader, StyledPlansContainer, MidBox } from "./plans.style";
import PlanCard from "./PlanCard.component";
import Spinner from "../utils/LoadingSpinner";
import plansList from "./plansList";
import FixelDataContext from "../../context/FixelDataContext";
import * as genNotifications from "../dashboard/notifications/generateNotificationContent";
import * as shouldNotify from "../dashboard/notifications/shouldDisplayNotification";
import ProgressBarNotification from "../dashboard/notifications/progressBar/ProgressBarNotification";
import CouponInput from "./CouponInput";

const Plans = () => {
  const [plans, setPlans] = useState(plansList);
  const [applyCoupon, setApplyCoupon] = useState(false);
  const { fullFixelData } = useContext(FixelDataContext);
  const [showSpinner, setShowSpinner] = useState(false);
  const [coupon,setCoupon] = useState(null);

  const renderPlans = () => {
    if (plansList.length) {
      return plans.map((plan) => {
        return (
          <li key={plan.id}>
            <PlanCard plan={plan} setShowSpinner={setShowSpinner} applyCoupon={applyCoupon} coupon={coupon} />
          </li>
        );
      });
    }
  };

  return (
    <StyledPlansContainer>
      <StyledHeader>
        <h2>Grow Your Business with Fixel</h2>
        <p>Choose the plan that fit your business goals</p>
      </StyledHeader>
      {shouldNotify.showPlanUsageProgressBar(fullFixelData) && (
          <MidBox>
            <ProgressBarNotification
                content={genNotifications.planUsageContent(
                    fullFixelData.THIS_MONTH.fixelStats.total,
                    fullFixelData.plan.max_traffic,
                )}
                type="planUsage"
            />
          </MidBox>
      )}
      <StyledCardsList>{showSpinner ? <Spinner /> : renderPlans()}</StyledCardsList>
      <CouponInput setPlans={setPlans} setApplyCoupon={setApplyCoupon} applyCoupon={applyCoupon} coupon={coupon} setCoupon={setCoupon} />
    </StyledPlansContainer>
  );
};
export default Plans;
